// extracted by mini-css-extract-plugin
export default {"container":"style_container__Mtgnj","text":"style_text__73Mba"};